// Dans votre fichier /components/textfields/textfield.object.js

import React from 'react';
import "./textfield.css";

const TextfieldObject = (props) => {
  
  const handleChange = (e) => {
    const value = e.target.value;
    
    if (props.editable !== false) {
      if (typeof props.handleChange === "function") {
        props.handleChange(props.setter, value);
      } else {
        props.setter(value);
      }
    }
  };

  return (
    <textarea
      style={{ fontFamily: "roboto", overflow: "hidden", resize: "none" }}
      className={"input_field"}
      placeholder={props.placeholder}
      
      
      value={props.value || ''}
      
      
      onChange={handleChange}
      
      rows={props.rows || 5}
      cols={props.cols || 50}
    />
  );
};

export default TextfieldObject;